import * as React from 'react';
import { SVGProps } from 'react';

const SvgDelete = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={15} height={16} viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
      d="M4.643.75a.75.75 0 0 1 .75-.75h3.714a.75.75 0 0 1 .75.75v2.036h3.893a.75.75 0 0 1 0 1.5h-13a.75.75 0 0 1 0-1.5h3.893V.75Zm3.714.75v1.286H6.143V1.5h2.214ZM2.429 6.321a.75.75 0 0 0-1.5 0v6.5a2.607 2.607 0 0 0 2.607 2.608h7.428a2.607 2.607 0 0 0 2.608-2.608v-6.5a.75.75 0 0 0-1.5 0v6.5c0 .612-.496 1.108-1.108 1.108H3.536a1.107 1.107 0 0 1-1.107-1.108v-6.5ZM8 7.25a.75.75 0 0 0-1.5 0v4.643a.75.75 0 0 0 1.5 0V7.25Zm2.036-.75a.75.75 0 0 1 .75.75v4.643a.75.75 0 0 1-1.5 0V7.25a.75.75 0 0 1 .75-.75Zm-4.822.75a.75.75 0 0 0-1.5 0v4.643a.75.75 0 0 0 1.5 0V7.25Z"
    />
  </svg>
);

export default SvgDelete;
